export default __webpack_public_path__ + "static/media/section-8.9b0e3de6.png";